import Button from 'app/shared-components/Button'
import {
    OrderStatuses,
} from 'app/enums/label.enums'

import {
    ContainersForPoolingType,
} from '../pooling.types'
import useStyles from './ReverseLogisticBtn.style'

interface OrderData {
    collectionDropoffPointId: number,
    selectedPreviousOrderId: number,
    containersForPooling: ContainersForPoolingType[],
}

type Props = {
    openCreateForm: (arg: OrderData) => void,
    containersForPooling: ContainersForPoolingType[],
    collectionDropoffPointId: number,
    orderStatus: OrderStatuses,
    id: number,
}

const ReverseLogisticBtn = ({
    collectionDropoffPointId,
    containersForPooling,
    openCreateForm,
    orderStatus,
    id,
}: Props) => {
    const {
        classes,
    } = useStyles()

    if (orderStatus !== OrderStatuses.CLOSED) {
        return null
    }

    return (
        <div className={classes.wrapper}>
            <Button
                label="RL"
                onClick={() => {
                    openCreateForm({
                        collectionDropoffPointId,
                        selectedPreviousOrderId: id,
                        containersForPooling,
                    })
                }}
                className={classes.btn}
            />
        </div>
    )
}

export default ReverseLogisticBtn
